// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as FeaturesProductsActions } from '../duck';
import { actions as AlertActions } from '../../alert/duck';
import FeatureProducts from '../components/FeaturedProducts';

import type { RootState } from '../../index';

function mapStateToProps(state: RootState) {
  return {
    localValues: state.localValues,
    localeState: state.locale,
    pageCanAsk: state.featuredProducts.pageCanAsk,
    page: state.featuredProducts.page,
    isFetchingProducts: state.featuredProducts.isFetchingProducts,
    fetchProductsError: state.featuredProducts.fetchProductsError,
    products: state.featuredProducts.products,
    chosenVariants: state.abTest.chosenVariants,
  };
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({
    ...FeaturesProductsActions,
    ...AlertActions,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(FeatureProducts);



// WEBPACK FOOTER //
// ./src/modules/featured-products/container/FeatureProductsContainer.js